import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

function SEO({ description, lang, meta, title }) {
  const {
    wpgraphql: {
      page: { seo },
    },
  } = useStaticQuery(
    graphql`
      query SEO {
        wpgraphql {
          page(id: "/strona-glowna/", idType: URI) {
            seo {
              title
              metaDesc
            }
          }
        }
      }
    `
  )

  const metaDescription = description || seo?.metaDesc || undefined

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title || seo?.title}
      meta={[
        {
          property: `robots`,
          content: `index, follow`,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: `indigital.pl`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
